import {accessTokenLocalStorageKey} from '../constants';
import storage from './storage';
import {saveUnauthorizedLogoutReasonIfNeeded} from './utils';

export const fetchJson = (url, options = {}) => {
    const requestHeaders =
        options.headers ||
        new Headers({
            Accept: 'application/json',
        });
    if (!(options && options.body && options.body instanceof FormData)) {
        requestHeaders.set('Content-Type', 'application/json');
    }
    if (options.user && options.user.authenticated && options.user.token) {
        requestHeaders.set('Authorization', options.user.token);
    } else {
        const urlObj = new URL(url);

        const token = storage.load(accessTokenLocalStorageKey);
        // let organisation = storage.load(organisationLocalStorageKey);

        if (token && token.id) {
            urlObj.searchParams.append('access_token', token.id);
        }

        // if (organisation && organisation.id) {
        //     urlObj.searchParams.append('organisation', organisation.id);
        // }
        url = urlObj.toString();
    }

    return fetch(url, {...options, headers: requestHeaders}).then((response) =>
        response.text().then((text) => ({
            status: response.status,
            statusText: response.statusText,
            headers: response.headers,
            body: text,
        })),
    ).then(({status, statusText, headers, body}) => {
        let json;
        try {
            json = body && JSON.parse(body);
        } catch (e) {
            console.log('Failed to JSON.parse body. Error: ', e);
            // not json, no big deal
        }

        if (status === 401) {
            saveUnauthorizedLogoutReasonIfNeeded();

            // storage.remove(organisationLocalStorageKey);
            storage.remove(accessTokenLocalStorageKey);
            return Promise.reject({redirectTo: '/signin', message: json && json.error && json.error.message});
        } else if (status < 200 || status >= 300) {
            let message = statusText;
            if (json && json.error) {
                if (json.error.message) {
                    message = json.error.message;
                } else if (json.error.messages && json.error.messages.length > 0) {
                    message = json.error.messages[0];
                }
            }

            return Promise.reject({message, status});
        }
        return {status, headers, body, json};
    }).catch((e) => {
        return Promise.reject(e);
    });
};

export const queryParameters = (data) =>
    Object.keys(data).map((key) => [key, data[key]].map(encodeURIComponent).join('=')).join('&');
